import React, { useEffect, useState } from 'react';
import QRCodeLib from 'qrcode';
import { useTheme } from '~contexts/ThemeContext';

const QRCodeGenerator = ({ user, event, isBigQr, qrCode, onQrPress }: any) => {
  const { colors } = useTheme();
  const [modalVisible, setModalVisible] = useState(false);
  const [qrData, setQrData] = useState(`${user?.uid}###${event?.event_id}###0`);
  const qrCanvasRef = React.useRef<HTMLCanvasElement>(null);
  const qrCanvasModalRef = React.useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (qrCode && qrCode.qr_code) {
      setQrData(qrCode.qr_code);
    }
  }, [qrCode]);

  useEffect(() => {
    const generateQRCode = async () => {
      if (qrCanvasRef.current && qrData) {
        try {
          const size = isBigQr ? 200 : 55;
          console.log('Generating QR code with size:', size, 'data:', qrData);
          
          // Set canvas dimensions
          qrCanvasRef.current.width = size;
          qrCanvasRef.current.height = size;
          
          await QRCodeLib.toCanvas(qrCanvasRef.current, qrData, {
            width: size,
            margin: 1,
            color: {
              dark: colors.black || '#000000',
              light: colors.white || '#FFFFFF',
            },
            errorCorrectionLevel: 'H',
          });
          
          console.log('QR code generated successfully');
        } catch (error) {
          console.error('QR Code generation error:', error);
        }
      }
    };

    generateQRCode();
  }, [qrData, isBigQr, colors]);

  useEffect(() => {
    const generateQRCodeModal = async () => {
      if (qrCanvasModalRef.current && qrData && modalVisible) {
        try {
          console.log('Generating QR code for modal with data:', qrData);
          
          // Set canvas dimensions
          qrCanvasModalRef.current.width = 170;
          qrCanvasModalRef.current.height = 170;
          
          await QRCodeLib.toCanvas(qrCanvasModalRef.current, qrData, {
            width: 170,
            margin: 1,
            color: {
              dark: colors.black || '#000000',
              light: colors.white || '#FFFFFF',
            },
            errorCorrectionLevel: 'H',
          });
          
          console.log('Modal QR code generated successfully');
        } catch (error) {
          console.error('Modal QR Code generation error:', error);
        }
      }
    };

    generateQRCodeModal();
  }, [qrData, modalVisible, colors]);

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const options: any = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };

    return date.toLocaleString('en-GB', options);
  };

  const qrSize = isBigQr ? 200 : 55;
  const containerStyle: React.CSSProperties = isBigQr
    ? {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
      }
    : {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxHeight: 70,
        width: 70,
        backgroundColor: colors.background,
        margin: 10,
        borderRadius: 10,
      };

  return (
    <div style={containerStyle}>
      <div
        onClick={() => {
          if (qrCode && qrCode.qr_code) {
            setModalVisible(true);
          } else {
            onQrPress?.();
          }
        }}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <canvas 
          ref={qrCanvasRef} 
          style={{ 
            display: 'block',
            width: isBigQr ? 200 : 55,
            height: isBigQr ? 200 : 55,
            border: `1px solid ${colors.border || '#ddd'}`,
            borderRadius: 4,
          }} 
        />
      </div>

      {modalVisible && (
        <div
          onClick={() => setModalVisible(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: colors.overlayBackground || 'rgba(0,0,0,0.5)',
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 300,
              backgroundColor: colors.white,
              borderRadius: 10,
              padding: 20,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            }}
          >
            <div
              onClick={() => setModalVisible(false)}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                fontSize: 18,
                color: colors.black,
                cursor: 'pointer',
              }}
            >
              ✕
            </div>
            <h2 style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10, color: colors.black }}>
              {event?.name}
            </h2>
            <p
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: colors.black,
                textAlign: 'center',
                marginBottom: 20,
                whiteSpace: 'pre-wrap',
              }}
            >
              {`${formatDate(event?.start_date)}\n ${event?.address_name}`}
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
              <canvas 
                ref={qrCanvasModalRef} 
                style={{ 
                  display: 'block',
                  width: 170,
                  height: 170,
                  border: `1px solid ${colors.border || '#ddd'}`,
                  borderRadius: 4,
                }} 
              />
            </div>
            <div
              onClick={() => console.log('pressed')}
              style={{ cursor: 'pointer', marginTop: 30 }}
            >
              <img
                src={require('~assets/images/addToAppleWallet.png')}
                style={{
                  height: 50,
                  objectFit: 'contain',
                }}
                alt="Add to Apple Wallet"
              />
            </div>
            <p style={{ fontSize: 12, color: colors.gray400, textAlign: 'center', marginTop: 10 }}>
              Show this to the cashier to validate your entrance to the event.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default QRCodeGenerator;
